import HTTP from '@/utils/http'

export default class UPModel extends HTTP {
  /**
   * @description 获取音频及图片资源
   * @see http://yapi.lilyenglish.cn/project/125/interface/api/6811
   */
  resource(data) {
    return this.post({
      url: '/imgup/img/url',
      data,
    })
  }

  /**
   * @description 获取阿里点播视频资源
   * query vid
   * @see http://yapi.lilyenglish.cn/mock/125/api/imgup/vod/aliyun/play/auth
   */
  aliInfo(params) {
    return this.get({
      url: '/imgup/vod/aliyun/play/auth',
      params,
    })
  }

  /**
   * 获取阿里资源内容
   * @param {*} data
   * @returns
   */
  getContent(data) {
    return this.post({
      url: '/imgup/img/data',
      data,
    })
  }

  /**
   * @description 获取音频地址和时长
   * @see https://yapi.dayuan1997.com/project/33/interface/api/9856
   */
  getAudioUrl(paths) {
    return this.post({
      url: '/imgup/audio/url',
      data: {
        paths,
      },
    })
  }
}
